import React from 'react';
import shape from '../../images/shapes/shape_poligon.svg';

const CompanyDescription = () => {
    return (
        <section className="company_description_section section_decoration text-center" style={{ fontFamily: 'Palqa', fontSize: 21 }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="ico_heading_block" data-aos="fade-up" data-aos-duration="600">
                            <h2 className="heading_text mb-4" >
                                О нас
                            </h2>
                        </div>
                        <div className="description_content" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                            <p className="info_description mb-4">
                                Мы — команда специалистов в affiliate-marketing, которая объединяет опыт, технологии и нестандартное мышление для достижения максимальных результатов. Наша миссия — помогать партнёрам и рекламодателям масштабировать бизнес, создавая устойчивые потоки трафика и превращая клики в прибыль.
                            </p>
                            <p className="info_description mb-0">
                                Мы работаем в различных вертикалях, а также запускаем собственные проекты. За счёт точного анализа, A/B тестов и уникального креатива мы формируем связки, которые приносят результат уже с первых дней запуска.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="decoration_item shape_shadow_1">
                <img src={shape} alt="Shape Color Shadow" />
            </div>
            <div className="decoration_item shape_shadow_2">
                <img src={shape} alt="Shape Color Shadow" />
            </div>
        </section>
    );
};

export default CompanyDescription;